import React, { useReducer, useEffect, useState } from 'react'
import styled from "styled-components";

const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

const clamp_tempo = (t) => clamp(t, 30, 300);

const Wrapper = styled.div`
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`

const Button = styled.button`
    padding: 10px;
    border: none;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
    height: 120px;
    width: 120px;
`

const InputWrapper = styled.div`
    padding-left: 15px;
`

const InputLabel = styled.label`
    font-size: 24px;
    display: block;
`

const InputElement = styled.input`
    font-size: 24px;
    display: block;
`

export default ({active = false}) => {
    const [tempo, setTempo] = useState(120)
    const [ready, setReady] = useState(false);
    const [started, setStarted] = useState(false);
    const [audioContext, setAudioContext] = useState(null);
    const [source, setSource] = useState(null);

    const handleKeyPress = e => {
        if(e.charCode === 13 || e.keyCode === 13){
            setTempo(e.target.value)
            setStarted(true);
        }
    }

    useEffect(() => {
        if(active){
            const audioContext = new (window.AudioContext || window.webkitAudioContext)()
            const _buffer = audioContext.createBuffer(1, audioContext.sampleRate * 2, audioContext.sampleRate);
            const _channel = _buffer.getChannelData(0);
            let _phase = 0;
            let _amp = 1;
            const _duration_frames = audioContext.sampleRate / 50;
            const _click_tone_frequency = 900;

            for(let i = 0; i < _duration_frames; i++){
                _channel[i] = Math.sin(_phase) * _amp;
                _phase += 2 * Math.PI * _click_tone_frequency / audioContext.sampleRate;
                if(_phase > 2 * Math.PI){
                    _phase -= 2 * Math.PI;
                }
                _amp -= 2.5 / _duration_frames;
            }

            const source = audioContext.createBufferSource();
            source.buffer = _buffer;
            source.loop = true;
            source.loopEnd = 1 / (clamp_tempo(tempo) / 60);
            source.connect(audioContext.destination);
            audioContext.suspend();
            source.start(0);

            setReady(true);
            setAudioContext(audioContext);
            setSource(source);
        }else{
            if(audioContext) {
                audioContext.close()
            }
            setAudioContext(null);
            setSource(null);
            setTempo(120);
            setReady(false);
            setStarted(false);
        }
    }, [active])

    useEffect(() => {
        if(!audioContext){
            return;
        }
        if(started && audioContext.state === 'suspended') {
            setTempo(clamp_tempo(tempo));
            if(source) {
                source.loopEnd = 1 / (clamp_tempo(tempo) / 60);
            }
            audioContext.resume();
        } else if(!started && audioContext.state === 'running') {
            audioContext.suspend();
        }
    }, [started])

    return (
        <Wrapper>
            <div>
                <Button onClick={() => setStarted(!started)}>
                    {started ?
                        //Pause Button
                        (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                            <path style={{fill: '#666'}} d="M30 0C13.458 0 0 13.458 0 30s13.458 30 30 30 30-13.458 30-30S46.542 0 30 0zm0 58C14.561 58 2 45.439 2 30S14.561 2 30 2s28 12.561 28 28-12.561 28-28 28z"/>
                            <path style={{fill: '#666'}} d="M33 46h8V14h-8v32zm2-30h4v28h-4V16zM19 46h8V14h-8v32zm2-30h4v28h-4V16z"/>
                        </svg>
                        ) :
                        //Play Button
                        (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                            <path style={{fill: '#666'}} d="M45.563 29.174l-22-15A1 1 0 0022 15v30a.999.999 0 001.563.826l22-15a1 1 0 000-1.652zM24 43.107V16.893L43.225 30 24 43.107z"/>
                            <path style={{fill: '#666'}} d="M30 0C13.458 0 0 13.458 0 30s13.458 30 30 30 30-13.458 30-30S46.542 0 30 0zm0 58C14.561 58 2 45.439 2 30S14.561 2 30 2s28 12.561 28 28-12.561 28-28 28z"/>
                        </svg>
                    )}
                </Button>
            </div>
            <InputWrapper>
                <InputLabel htmlFor="tempo">BPM</InputLabel>
                <InputElement type="number" id="tempo" disabled={started} value={tempo} onChange={e => setTempo(e.target.value)} onKeyPress={handleKeyPress} />
            </InputWrapper>

        </Wrapper>
    )
}
